import { defineField, defineType } from 'sanity'

export default defineType({
  title: 'Gallery box',
  name: 'galleryBox',
  type: 'object',
  fields: [
    defineField({
      title: 'Title',
      name: 'title',
      type: 'string',
      initialValue: 'Gallery box block',
      readOnly: true,
    }),
    defineField({
      title: 'Desktop Image',
      name: 'desktopImage',
      type: 'image',
      description: 'Image displayed on desktop devices (falls back to default if not set)',
      options: {
        hotspot: true,
      },
    }),
    defineField({
      title: 'Mobile Image',
      name: 'mobileImage',
      type: 'image',
      description: 'Image displayed on mobile devices (falls back to default if not set)',
      options: {
        hotspot: true,
      },
    }),
  ],
})
